import { useLocation, useNavigate } from 'react-router-dom';

const useQParams = () => {
  const { search } = useLocation();

  return new URLSearchParams(search);
};

export const useQParam = (key: string) => {
  const params = useQParams();

  return params.get(key);
};

export const useAddQParam = () => {
  const params = useQParams();

  return (key: string, value?: string) => {
    if (params.has(key)) params.delete(key);

    params.append(key, value || 'true');

    return params;
  };
};

export const usePushQParam = () => {
  const navigate = useNavigate();

  return (params: URLSearchParams) => navigate({ search: params.toString() });
};
